"use strict";

export default function listenResize(target, handler = (w, h) => {}, schedule = 100) {
	
	if (!target)
		return;
	
	let width = target.clientWidth;
	let height = target.clientHeight;
	
	setInterval(() => {
		if (width !== target.clientWidth || height !== target.clientHeight) {
			width = target.clientWidth;
			height = target.clientHeight;
			handler(width, height);
		}
	}, schedule);
}


// WEBPACK FOOTER //
// ./~/vwa/utils/listenResize.js